<template>
  <div class="wj_wrap">
      <div class="wj_container">
        <div class="search">
            <span class="lbl_title">快递单号：</span>
            <el-input id="inputBox"  v-model="expressNo" autofocus ref="inputExpress"
                style="width: 500px;"
                placeholder="请使用扫描枪或手动输入快递单号，回车确认" 
                :disabled="disable"
                clearable  @clear="init()" 
                ></el-input>
            <el-button style="margin-left: 20px;width:120px;padding:20px;border-radio:10px;" 
            @click="confirm()" type="primary" :loading="disable">{{disable?"确认中":"确认"}}</el-button>        
        </div>
      </div>
         <!-- //表格 -->
      <div class="table_container">
        <div class="title">最近签收订单：</div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        stripe
        id="printTable"
        ref="table"
      >
        <el-table-column label="名称" min-width="200px" align="left">
          <template slot-scope="scope">
            <div style="display: flex">
              <div style="flex: 8">
                <div>{{ scope.row.productName }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          label="客户"
          prop="userName"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.userName }}
          </template>
        </el-table-column>
        <el-table-column
          label="vip号"
          prop="vipCode"
          min-width="60px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.vipCode }}
          </template>
        </el-table-column>
        <el-table-column
          label="物流公司"
          prop="expressCompany"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="运单号"
          prop="expressNo"
          min-width="100px"
          align="left"
        >
           <template slot-scope="scope">
            {{scope.row.expressNo}}
           </template>
        </el-table-column>
        <el-table-column
          label="商品价值"
          prop="predictTotal"
          min-width="60px"
          align="center"
        >
        </el-table-column>
        
        <el-table-column label="状态" min-width="70px" align="center">
          <!-- <template slot-scope="scope"> -->
           <span class="sign">已签收</span>
          <!-- </template> -->
        </el-table-column>
        <!-- </el-table-column> -->
        <el-table-column
          label="下单时间"
          min-width="80px"
          align="center"
          prop="addDate"
        >
        </el-table-column>
         <el-table-column
          label="签收时间"
          min-width="80px"
          align="center"
          prop="expressTime"
        >
          <template slot-scope="scope">
           <span class="sign">{{toDate(scope.row.expressTime,"yyyy-MM-dd")}}</span>
        </template>
        </el-table-column>
      
      </el-table>
      
      </div>
        <el-dialog
        :visible.sync="dialog.show"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        width="900px"
        center @close="cancel()"
        >
        <div class="search_result">
           <div class="title">快递签收（{{expressNo.replace(/\s/g,"")}}）</div>
           <div class="main">
               <div class="tip_msg" v-if="msg">
                    <el-alert :title="msg" type="error" :closable="false"></el-alert>
               </div>
               <el-form ref="form" size="mini">
                 <div v-if="orderInfo" style="padding:0 30px;">
                <el-form-item label="用户：">
                    {{orderInfo && orderInfo.vipCode}} {{orderInfo && orderInfo.userName}}
                </el-form-item>
                <el-form-item label="订单：">
                    {{orderInfo && orderInfo.orderNo}}
                </el-form-item>
                <el-form-item label="商品：">
                    {{orderInfo && orderInfo.detailList.length>0 && orderInfo.detailList[0].productName}}...等{{orderInfo && orderInfo.detailList.length}}款
                </el-form-item>
                <el-form-item label="价值：">
                    {{orderInfo && orderInfo.predictTotal}}元
                </el-form-item>
                <el-form-item label="时间：">
                   <span v-if="orderInfo && orderInfo.expressStatus==0">{{toDate(orderInfo && orderInfo.addTime,"yyyy-MM-dd hh:mm")}} 录入</span>
                   <span v-if="orderInfo && orderInfo.expressStatus==1">{{toDate(orderInfo && orderInfo.expressTime,"yyyy-MM-dd hh:mm")}} 签收</span>
                </el-form-item>
                <el-form-item label="">
                <el-alert title="按回车键确认签收，按ESC取消" type="info" :closable="false"></el-alert>
                </el-form-item>
                <el-form-item v-if="orderInfo && orderInfo.expressStatus==0">
                    <el-button type="primary" size="medium" @click="confirm()">确认签收</el-button>
                    <el-button type="info" size="medium" @click="cancel()">取消</el-button>
                </el-form-item>
                 <el-form-item v-if="orderInfo && orderInfo.expressStatus==1">
                    <el-button type="primary" size="medium" @click="confirm()">确认</el-button>
                </el-form-item>
                </div>
                
                <div v-if="!orderInfo" style="margin-top:50px;text-align:center">
                  <el-form-item>
                    <el-button type="primary" size="medium" @click="cancel()">确认</el-button>
                    <el-button type="primary" size="medium" @click="openOrderDailog()">补录订单</el-button>
                   </el-form-item>
                </div>
                </el-form>
           </div>
        </div>
        </el-dialog>

        <el-dialog
      :visible.sync="orderDialog.show"
      :title="orderDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="520px"
      center :show-close="false"
    >
      <el-form
        :model="orderDialog.data"
        :rules="orderDialog.form_rules"
        ref="editForm"
        label-position="right"
        label-width="120px"
      >
        <el-form-item prop="expressNo" label="运单号：">
          <el-input
            v-model.trim="expressNo" type="text"
            placeholder="请输入运单号"
            style="width: 300px"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item prop="tel" label="VIP号：">
          <el-input
            v-model.trim="orderDialog.data.vipCode"
            type="text"
            placeholder="请输入VIP号"
            style="width: 300px"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item prop="goodType" label="物流公司：">
           <el-select v-model="orderDialog.data.expressCompany" clearable placeholder="物流公司">
              <el-option v-for="item in expressList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
              </el-option>
           </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderDialog.show = false">取 消</el-button>
        <el-button type="primary" @click="submitOrder()">确 定</el-button>
      </span>
    </el-dialog>

      </div>

  <!-- </div> -->
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as date from "utils/date";
import * as order from "@/api/order";
import * as confirmApi from "@/api/confirm";
import { axios } from "utils/";
export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (!value) {
        let text;
        if (rule.field == "vipCode") text = "请输入VIP号";
        else if (rule.field == "expressCompany") text = "请选择物流公司";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      tableData: [],
      expressNo: "",
      orderInfo: null,
      disable: false,
      isSearch: false,
      msg: "",
      dialog: {
        show: false,
      },
      expressList: [],
      orderDialog: {
        show: false,
        title: "补录信息",
        data: {
          vipCode: "",
          expressCompany: "",
        },
        form_rules: {
          vipCode: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          expressCompany: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
        },
      },
    };
  },
  created() {
    let that = this;
    that.getOrderList();
    that.getExpressList();
  },
  methods: {
    init() {
      this.isSearch = false;
      this.dialog.show = false;
      // this.expressNo = "";
      this.orderInfo = null;
      this.msg = "";
      this.getOrderList();
    },
    openOrderDailog() {
      this.orderDialog.show = true;
    },
    confirm() {
      //  if (this.isSearch) return;
      //  this.isSearch = true;
      console.log("start...");
      this.msg = "";
      if (!this.expressNo) return;
      if (
        this.orderInfo &&
        this.expressNo.toUpperCase() ==
          this.orderInfo.expressNo.toUpperCase() &&
        this.orderInfo.expressStatus == 1
      ) {
        //已经签收
        this.init();
        return;
      } else if (
        this.orderInfo &&
        this.expressNo.toUpperCase() ==
          this.orderInfo.expressNo.toUpperCase() &&
        this.orderInfo.expressStatus == 0
      ) {
        //确认签收
        this.updateExpress();
        return;
      } else {
        this.orderInfo = null;
        this.dialog.show = true;
        this.getOrderInfo();
      }
    },
    cancel() {
      this.init();
    },
    submitOrder() {
      let that = this;
      let data = {
        expressNo: that.expressNo,
        vipCode: that.orderDialog.data.vipCode,
        expressCompany: that.orderDialog.data.expressCompany,
      };
      that.$refs.editForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "提交中...",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)",
          });
          order.orderSupplement(data).then(function (res) {
            loading.close();
            if (res.data.code != 0) {
              return that.$message.error(res.data.msg || "操作异常");
            }
            that.$message({ message: "提交成功", type: "success" });
            that.getOrderList();
            that.orderDialog.show = false;
            that.cancel();
          });
        }
      });
    },
    inputOrder(event) {
      let that = this;
      if (!this.expressNo) return;
      that.dialog.show = true;
      this.getOrderInfo();
    },
    async getOrderInfo() {
      let that = this;
      let data = {};
      data.expressNo = that.expressNo.replace(/\s/g,"");
      if (!that.expressNo) {
        that.orderInfo = null;
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      await order.searchOrderByExpress(data).then(function (res) {
        loading.close();
        that.isSearch = false;
        if (res.data.code != 0) {
          that.msg = res.data.msg || "NO DATA";
          //that.$message.error(res.data.msg ||"NO DATA");

          if(res.data.code == 1101){
            that.$message.error(res.data.msg);
            that.dialog.show = false;
            return;
          }
          return;
        }
        that.orderInfo =
          res.data.data && res.data.data.orderNo ? res.data.data : null;
        if(res.data.code != 1101){
        if (!that.orderInfo) {
          that.msg = "签收出错，系统无匹配运单";
        } else if (that.orderInfo.expressStatus == 1) {
          that.msg = "本运单已签收";
        }
        }
      });
    },
    updateExpress() {
      let that = this;
      let data = {};
      data.orderNo = that.orderInfo.orderNo;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      order.updateOrderExpress(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.msg = res.data.msg || "操作失败";
          //that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message.success("签收成功");
        that.init();
        // that.msg = "本运单签收成功";
        //that.$message.success("签收成功");
        //that.getOrderInfo();
      });
    },
    getOrderList() {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let data = {
        pageIndex: 1,
        pageSize: 10,
        expressStatus: 1,
      };

      order.getOrderList(data).then((res) => {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.deliveryDate = "";
              val.statementDate = "";
              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
                val.deliveryDate = mUtils
                  .formatDate(new Date(val.deliveryTime))
                  .substring(0, 10);
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
                val.statementDate = mUtils
                  .formatDate(new Date(val.statementTime))
                  .substring(0, 10);
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              if (val.userRemark) {
                val.userRemark = val.userRemar;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure =
                  val.productLong +
                  "*" +
                  val.productWidth +
                  "*" +
                  val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
              if (val.detailList && val.detailList.length>0 && val.detailList[0].productName.length > 20) {
                if (val.detailList.length >= 2) {
                  val.productName =val.detailList[0].productName.substring(0, 20) +"...等" +val.detailList.length +"款";
                } else if (val.detailList && val.detailList.length>0){
                  val.productName = val.detailList[0].productName.substring(0,20);
                }
              } else {
                if (val.detailList && val.detailList.length>0 && val.detailList.length >= 2) {
                  val.productName =val.detailList[0].productName +"...等" +val.detailList.length +"款";
                } else if (val.detailList && val.detailList.length>0) {
                  val.productName = val.detailList[0].productName;
                }
              }
            });
            that.tableData = res.data.data.list;
          } else {
            that.tableData = [];
          }
        }
      });
    },
    //获取
    getExpressList() {
      let that = this;
      let data = {};
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      confirmApi.expressList(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.$message.error("获取快递公司列表失败");
          return;
        }
        that.expressList = res.data.data;
      });
    },
    messageAlert(title) {
      this.$alert(title, {
        confirmButtonText: "确定",
        callback: (action) => {},
      });
    },
    goodTypeName(goodType) {
      let str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
  },
  mounted() {
    // 添加键盘Esc事件
    this.$nextTick(() => {
      document.getElementById('inputBox').addEventListener("keyup", (e) => {
        if (e.keyCode == 27) {
          this.cancel();
          //this.messageAlert("esc");
        } else if (e.keyCode == 13) {
          if (!this.orderInfo && this.msg) {
            this.cancel();
          } else {
            this.confirm();
          }
        }
      });
    });
  },
};
</script>
<style  lang="less" scoped>
.wj_wrap {
  padding-bottom: 50px;
  .wj_container {
    width: 800px;
    margin: 50px auto;
    .search {
      .lbl_title {
        font-size: 24px;
        font-weight: bold;
      }
    }
  }

  .tip_msg {
    margin-left: 20px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .no_data {
    margin-top: 30px;
  }
  .search_result {
    min-height: 300px;
    .title {
      font-size: 24px;
      font-weight: bold;
      margin-left: 20px;
    }
    .main {
      margin-top: 20px;
    }
  }

  .table_container {
    width: 85%;
    margin: 0 auto;
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .sign {
      font-size: 12px;
      color: #e6a23c;
    }
  }
}
</style>
<style lang="less">
.wj_container {
  .search {
    .el-input__inner {
      height: 60px;
      line-height: 60px;
      border-radius: 10px;
    }
  }
}
.search_result {
  .el-alert__title {
    font-size: 18px;
  }
  .el-button--medium {
    padding: 10px 40px;
  }
  .el-form-item__label {
    font-size: 18px;
    font-weight: bold;
  }
  .el-form-item__content {
    font-size: 18px;
  }
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin: 15px 0;
  }
}
</style>


// WEBPACK FOOTER //
// checkExpress.vue?2d455500